import { mergeNewData } from '../../../redux/data-utils';
import { Capability } from '../../../device/device-capability';
export const default_track = {
    loading: false,
    error: null,
    mintime: 0,
    maxtime: 0,
    viewport: [0, 0],
    confirmed_viewport: [0, 0],
    ghost_at_time: null,
    hover_points_on_map: [],
    selected_point_on_map: null,
    raw_data: null,
    device_id: -1,
};
function applyNewDataTrack(state, action) {
    //Если это устройство не выбрано, то ничего к нему не добавляем
    const track = findDeviceTrack(state, action.device_id);
    if (track == null) {
        return state;
    }
    const caps = action.device_capabilities;
    if (caps == null) {
        return state;
    }
    const needed_data_types = caps.includes(Capability.has_autoscan_tracking)
        ? ['gps', 'events', 'autoscan', 'autoscan_misc']
        : ['gps', 'events'];
    let any_needed = false;
    for (const key of Object.keys(action.data ?? {}))
        if (needed_data_types.includes(key)) {
            any_needed = true;
            break;
        }
    if (!any_needed) {
        return state;
    }
    const raw_data = mergeNewData(track.raw_data, action.data, track.mintime, track.maxtime, needed_data_types);
    if (raw_data !== track.raw_data) {
        return changeCurrentDeviceTrack(state, action.device_id, {
            raw_data,
        });
    }
    return state;
}
export const findDeviceTrack = (state, track_device_id) => {
    return state.find(({ device_id }) => track_device_id == device_id);
};
const addDeviceTrack = (state, new_track) => {
    const current_track = findDeviceTrack(state, new_track.device_id);
    if (current_track != null) {
        return state.map((device_track) => current_track.device_id == device_track.device_id ? new_track : device_track);
    }
    if (state.length === 5) {
        state.splice(0, 1);
        return [...state, new_track];
    }
    return [...state, new_track];
};
const changeCurrentDeviceTrack = (state, device_id, changes) => {
    const track = findDeviceTrack(state, device_id);
    if (!track) {
        return state;
    }
    return addDeviceTrack(state, {
        ...track,
        ...changes,
    });
};
export const reducer = (state = [], action) => {
    switch (action.type) {
        case 'LOAD_TRACK__REQUEST':
            return addDeviceTrack(state, {
                ...default_track,
                mintime: action.mintime,
                maxtime: action.maxtime,
                viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                confirmed_viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                device_id: action.device_id,
                loading: true,
            });
        case 'LOAD_TRACK__OK':
            return addDeviceTrack(state, {
                ...default_track,
                loading: false,
                mintime: action.mintime,
                maxtime: action.maxtime,
                viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                confirmed_viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                device_id: action.device_id,
                raw_data: action.raw_data,
            });
        case 'LOAD_TRACK__FAIL':
            return addDeviceTrack(state, {
                ...default_track,
                loading: false,
                error: action.error,
                mintime: action.mintime,
                maxtime: action.maxtime,
                viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                confirmed_viewport: [action.mintime * 1e3, action.maxtime * 1e3],
                device_id: action.device_id,
            });
        case 'SET_TRACKING_VIEWPORT':
            return changeCurrentDeviceTrack(state, action.device_id, {
                viewport: [action.mintime_ms, action.maxtime_ms],
            });
        case 'SET_CONFIRMED_TRACKING_VIEWPORT':
            return changeCurrentDeviceTrack(state, action.device_id, {
                viewport: [action.mintime_ms, action.maxtime_ms],
                confirmed_viewport: [action.mintime_ms, action.maxtime_ms],
            });
        case 'SHOW_GHOST_AT_TIME':
            return changeCurrentDeviceTrack(state, action.device_id, {
                ghost_at_time: action.ghost_at_time,
            });
        case 'HOVER_POINTS_ON_MAP':
            return changeCurrentDeviceTrack(state, action.device_id, {
                hover_points_on_map: action.points,
            });
        case 'SELECTED_POINT_ON_MAP':
            return changeCurrentDeviceTrack(state, action.device_id, {
                selected_point_on_map: action.point,
            });
        case 'APPLY_NEW_DATA':
            return applyNewDataTrack(state, action);
        case 'APPLY_MANY_NEW_DATA':
            Object.entries(action.map ?? {}).forEach(([device_id, msgs]) => {
                const dev_id = parseInt(device_id, 10);
                msgs.forEach((msg) => (state = reducer(state, {
                    type: 'APPLY_NEW_DATA',
                    device_id: dev_id,
                    data: msg,
                    device_capabilities: action.capabilities[dev_id],
                })));
            });
            return state;
        default:
            return state;
    }
};
